import styled from 'styled-components';

export const StyledUserList = styled.div`
  ${({ theme }) => theme.mixins.Container('COLUMN')}
`;
